<template>
  <v-container v-if="list.length" class="py-0 container-large">
    <div class="justify-center grid-list">
      <HighlightMenuCard
        v-for="(item, keyList) in list"
        :key="keyList"
        v-bind="item"
      />
    </div>
  </v-container>
</template>

<script>
import HighlightMenuCard from "../cards/HighlightMenuCard.vue";

export default {
  computed: {
    externalLinks() {
      return this.$rest("external-links").item;
    },
    list() {
      const list = [];

      list.push({
        title: "Faça sua",
        subtitle: "Matrícula",
        image: require("../../assets/img/registration.png"),
        link: {
          to: "/matricula",
        },
      });

      if (this.externalLinks.student_area)
        list.push({
          title: "Área do",
          subtitle: "Aluno",
          image: require("../../assets/img/student.png"),
          link: {
            href: this.externalLinks.student_area,
            target: "_blank",
          },
        });

      if (this.externalLinks.teacher_area)
        list.push({
          title: "Área do",
          subtitle: "Professor",
          image: require("../../assets/img/teacher.png"),
          link: {
            href: this.externalLinks.teacher_area,
            target: "_blank",
          },
        });

      list.push({
        title: "Calendário",
        subtitle: "Escolar",
        image: require("../../assets/img/calendar.png"),
        link: {
          to: "/calendario-escolar",
        },
      });

      return list;
    },
  },
  components: {
    HighlightMenuCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 0;
  grid-template-columns: repeat(4, 25%);
  margin-top: -48px;
  position: relative;

  @media screen and (max-width: 959.9px) {
    grid-template-columns: repeat(2, minmax(50%, 360px));
    margin-top: 64px;
  }
}
</style>
